// Bound speculative work only. User playback never waits for this queue.
export function createVideoWarmupQueue(limit = 3) {
  const pending = [];
  const active = new Set();
  const holds = new Set();
  const pump = () => {
    if (holds.size) return;
    while (active.size < limit) {
      const index = pending.findIndex((job) => ![...active].some((other) => other.key === job.key));
      if (index < 0) return;
      const [job] = pending.splice(index, 1);
      active.add(job);
      job.start(() => {
        if (!active.delete(job)) return;
        pump();
      });
    }
  };
  const enqueue = (key, start) => {
    const job = { key, start };
    pending.push(job);
    pump();
    return () => {
      const index = pending.indexOf(job);
      if (index >= 0) pending.splice(index, 1);
      active.delete(job);
      pump();
    };
  };
  enqueue.hold = () => {
    const token = {};
    holds.add(token);
    return () => { holds.delete(token); pump(); };
  };
  return enqueue;
}
